/**
 * Branches/departments a college can select for "Courses Offered".
 * Kept separate from COURSES_LIST (education-master-data.ts), which lists
 * degree programs (BCA, B.Tech, etc.) reused as-is for "Streams".
 */
export const COLLEGE_BRANCHES_LIST = [
	'Computer Science',
	'Information Technology',
	'Electronics & Communication',
	'Electrical',
	'Mechanical',
	'Civil',
	'Chemical',
	'Biotechnology',
	'Aeronautical',
	'Automobile',
	'Commerce',
	'Business Administration',
	'Arts & Humanities',
	'Science',
	'Other'
];

/**
 * Placement industries a college's students typically get placed into.
 * Mirrors the backend's IndustryType enum (models/company_management.py)
 * value-for-value — the same industry taxonomy already used for companies,
 * reused here rather than duplicating a separate hardcoded list.
 */
export const PLACEMENT_INDUSTRY_TYPES = [
	'Information Technology',
	'Finance & Banking',
	'Healthcare',
	'Education',
	'Manufacturing',
	'Retail & E-Commerce',
	'Consulting',
	'Media & Entertainment',
	'Telecom',
	'Automotive',
	'Real Estate',
	'Other'
];
